import React, {PropTypes} from "react";
import InfoTabMain from "./InfoTabMain";


class SearchTab extends React.Component {

  constructor(props) {
    super(props);
    this.download_excel = this.download_excel.bind(this);
  }

  download_excel() {
    var data = [["Mr.Ninth"]];
    var csvContent = "data:text/csv;charset=utf-8,";
    data.forEach(function (infoArray, index) {

      let dataString = infoArray.join(",");
      csvContent += index < data.length ? dataString + "\n" : dataString;

    });
    var encodedUri = encodeURI(csvContent);
    window.open(encodedUri);
  }


  render() {

    let path = window.location.hash.substr(1).split('?')[0];
    const role = window.location.hash.split('?')[0].split('/')[3];

    path = path + '/edit/';

    //const Butt=;

    return (

      <InfoTabMain
        dates={this.props.dates}
        attendanceMain={this.props.attendanceMain}
        message={this.props.message}/>

    );
  }
}

SearchTab.propTypes = {};

export default SearchTab;





/** WEBPACK FOOTER **
 ** ./src/feature/attendance/MyAttendance/SearchTab.js
 **/